import React from "react";
import PropTypes from "prop-types";

const FullWidthImage = ({
	imgSrc,
	imgAlt,
	imgCaption,
	elClass,
	imgSrcset,
	imgSizes,
	imgHeight,
	imgWidth,
}) => {
	
	return (
		<figure className={`full-width-img ${elClass}`}>
			<div className="aspect-ratio-box">
				<img
					sizes={imgSizes}
					srcSet={imgSrcset}
					src={imgSrc}
					alt={imgAlt}
					loading="lazy"
					width={imgWidth}
					height={imgHeight}
				/>
			</div>
			<figcaption className="img-caption">{imgCaption}</figcaption>
		</figure>
	);
};

export default FullWidthImage;

FullWidthImage.propTypes = {
	imgSrc: PropTypes.string.isRequired,
	imgSrcset: PropTypes.string,
	imgSizes: PropTypes.string,
	imgCaption: PropTypes.string.isRequired,
	elClass: PropTypes.string.isRequired,
	imgAlt: PropTypes.string,
	imgHeight: PropTypes.string,
	imgWidth: PropTypes.string,
};
